const INTERCOM_APP_ID = 'sa8p3fk0';

export { INTERCOM_APP_ID };
